<script lang="ts" setup>
import Desktop from '@/components/desktop/pages/sports/index.vue'
import Mobile from '@/components/mobile/pages/sports/index.vue'
import { usePageByDevice } from '~/composables/common/use-page-by-device'
const { component } = usePageByDevice(Desktop, Mobile)
</script>

<template>
  <component :is="component" />
</template>
